import { useMemo, useState } from 'react';
import SectionHeading from './SectionHeading';
import { characterGroups, characters } from '@/mocks/characters';

export default function CharactersSection() {
  const [activeGroup, setActiveGroup] = useState(characterGroups[0]);

  const filtered = useMemo(() => {
    if (activeGroup === characterGroups[0]) return characters;
    return characters.filter((item) => item.group === activeGroup);
  }, [activeGroup]);

  return (
    <section id="characters" className="scroll-mt-24 bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Characters"
          title="人物角色：谁在推动故事，谁在默默旁观"
          desc="按关系类型筛选，快速找到你关心的那条线。每个角色的动机与处境各不相同，正是这些差异撑起了群像。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {characterGroups.map((group) => {
            const isActive = group === activeGroup;
            return (
              <button
                key={group}
                type="button"
                onClick={() => setActiveGroup(group)}
                aria-pressed={isActive}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {group}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <div className="min-w-0">
                  <h3 className="truncate font-heading text-base font-semibold text-foreground-950">
                    {item.name}
                  </h3>
                  <p className="mt-0.5 truncate text-xs text-foreground-500">{item.meta}</p>
                </div>
              </div>

              <span className="mt-3 inline-flex w-fit rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-xs text-accent-900">
                {item.tag}
              </span>

              <p className="mt-3 flex-1 text-xs leading-relaxed text-foreground-700 md:text-sm">{item.desc}</p>

              <p className="mt-4 flex items-start gap-2 rounded-md bg-background-50 p-3 text-xs text-foreground-600">
                <i className="ri-arrow-right-s-line mt-0.5 text-base text-primary-500"></i>
                {item.line}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}